import booleanMaker from 'reducersMakers/booleanMaker';
import * as actions from 'actions';

export default booleanMaker({
  booleanName: 'isSubmitting',
  trueTypes: [
    actions.FEED_QUESTIONNAIRE_SUBMIT
  ],
  falseTypes: [
    actions.FEED_QUESTIONNAIRE_SUBMIT_SUCCESS,
    actions.FEED_QUESTIONNAIRE_SUBMIT_ERROR
  ]
});




/** WEBPACK FOOTER **
 ** ./src/members/state/feed/feedQuestionnaires/feedQuestionnairesSubmission/reducer.js
 **/